import { d as h, b as bem, c as isResponsiveProperty, m as mapResponsiveProperty, p as parseResponsiveProperty, e as serializeResponsiveProperty } from './p-c44c2366.js';

const generateClassNames = bem('card-body');
const CardBody = ({ appearance, layout = 'normal', headline, text, logoUrl, tag, isLogoNarrow, logoAlt, metaText, textClamp = 2, headlineClamp = 5, hasGradientBackground, class: classname, textKind = 'subtle', metaTextPart = 'meta-text', url, }) => {
    const hasMeta = !!logoUrl || !!tag || !!metaText || !!url;
    const getTextSize = (layout, layoutToSizeMap) => {
        if (isResponsiveProperty(layout)) {
            const responsiveTextSize = mapResponsiveProperty(parseResponsiveProperty(layout), layoutToSizeMap);
            return serializeResponsiveProperty(responsiveTextSize);
        }
        return layoutToSizeMap[layout];
    };
    const getLayoutClasses = () => {
        if (!layout) {
            return;
        }
        return isResponsiveProperty(layout) ? parseResponsiveProperty(layout) : layout;
    };
    const splitDomain = (url) => {
        const [firstPart, secondPart] = url.split('.');
        const lastChar = firstPart[firstPart.length - 1];
        return [firstPart.slice(0, -1), `${lastChar}.${secondPart}`];
    };
    const domainParts = url && splitDomain(url);
    return (h("div", { class: [
            generateClassNames({
                'layout': getLayoutClasses(),
                'gradient-background': hasGradientBackground,
            }),
            classname,
        ].join(' '), part: "body" },
        h("cosmos-mode", { mode: appearance, class: "card-body__container" },
            h("cosmos-title", { class: generateClassNames('headline'), clamp: headlineClamp, size: getTextSize(layout, { normal: 'small', compact: 'xx-small' }), weight: "bold", exportparts: "base: headline" },
                h("span", { id: "headline" }, headline)),
            h("cosmos-text", { clamp: textClamp, class: generateClassNames('text'), size: getTextSize(layout, { normal: 'small', compact: 'x-small' }), kind: textKind, exportparts: "base: text" }, text),
            hasMeta && (h("div", { class: generateClassNames('meta'), part: "meta" },
                domainParts && (h("div", { class: generateClassNames('url', { appearance }) },
                    h("cosmos-icon-external-link", { class: generateClassNames('url-icon') }),
                    h("cosmos-text", { class: generateClassNames('url-text'), kind: textKind, size: getTextSize(layout, { normal: 'x-small', compact: 'xx-small' }), tag: "span" },
                        h("div", { class: generateClassNames('url-domain'), id: "url", "aria-label": url },
                            h("span", { "aria-hidden": "true" }, domainParts[0]),
                            h("span", { "aria-hidden": "true" }, domainParts[1]))))),
                logoUrl ? (h("img", { class: generateClassNames('logo', { narrow: isLogoNarrow }), src: logoUrl, alt: logoAlt, part: "logo", id: "logo" })) : (tag && (h("cosmos-text", { class: generateClassNames('tag'), clamp: 1, kind: textKind, size: getTextSize(layout, { normal: 'x-small', compact: 'xx-small' }), weight: "bold", exportparts: "base: tag" },
                    h("span", { id: "tag" }, tag)))),
                metaText && (h("cosmos-text", { class: generateClassNames('meta-text'), clamp: 1, kind: textKind, size: getTextSize(layout, { normal: 'x-small', compact: 'xx-small' }), "data-testid": "meta-text", exportparts: `base: ${metaTextPart}` },
                    h("span", { id: "meta-text" }, metaText))))))));
};

export { CardBody as C };
